module.exports = __webpack_public_path__ + "static/media/up-arrow-red.5b37f43f.svg";